var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.message.telephone))]),_c('td',[_vm._v(_vm._s(_vm.$t(_vm.message.status)))]),_c('td',[_vm._v(_vm._s(_vm.message.sms_number))])])}
var staticRenderFns = []

export { render, staticRenderFns }